<template>
	<div>
		<div class="mian" v-loading="loading">
			<div class="tabbox fcc">
				<div :class="category_id == '7'?'tab-a fcc':'tab fcc'" @click="changecurrent('7')">供应商入库指南</div>
				<div :class="category_id == '8'?'tab-a fcc':'tab fcc'" @click="changecurrent('8')">投标指南</div>
			</div>
			<div v-html="info"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				category_id: '7',
				info: ''

			}
		},
		watch: {
			$route(to, from) {
				this.category_id = this.$route.query.id
				this.getinfo();
			}
		},
		created() {
			if (this.$route.query.id) {
				this.category_id = this.$route.query.id
			}
			this.getinfo();
		},
		methods: {
			changecurrent(category_id) {
				this.category_id = category_id;
				this.getinfo();
			},
			getinfo(id) {
				this.loading = true;
				if (this.category_id == '7') {
					this.$api.home.rkzn().then(res => {
						if (res.code == 1) {
							this.info = res.data;
						}
						this.loading = false;
					})
				} else {
					this.$api.home.zbzn().then(res => {
						if (res.code == 1) {
							this.info = res.data;
						}
						this.loading = false;
					})
				}
			}
		}
	}
</script>

<style scoped>
	.mian {
		width: 1200px;
		margin: 50px auto;
	}

	.mian .tabbox {
		cursor: pointer;
		margin-bottom: 50px;
	}

	.mian .tabbox .tab {
		width: 156px;
		height: 38px;
		background: #ECECEC;
		border-radius: 6px;
		font-size: 16px;
		margin-left: 20px;
	}

	.mian .tabbox .tab-a {
		width: 156px;
		height: 38px;
		background: #0B457A;
		border-radius: 6px;
		font-size: 16px;
		color: #ffffff;
		margin-left: 20px;
	}

	.mian .list {
		width: 1000px;
		height: 54px;
		margin: 0 auto;
		border-bottom: #ADADAD dashed 1px;
		cursor: pointer;
	}

	.mian .list:hover {
		color: #0B457A;
		font-weight: bold;
	}

	.mian .list:hover .time {
		color: #0B457A;
	}

	.mian .list .title {
		width: 750px;
		font-size: 16px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.mian .list .time {
		font-size: 16px;
		color: #333333;
	}
</style>